import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRetweet } from "@fortawesome/free-solid-svg-icons";
import "../styles/InfoTooltip.css";

const TipButton = ({ tip, onChange, isStudentView = false, onFlip }) => {
  if (isStudentView && !tip) {
    return null;
  }

  const handleClick = (e) => {
    e.stopPropagation();
    if (isStudentView && onFlip) {
      // Flip the card to show the tip on the back
      onFlip(e);
    } else if (!isStudentView && onFlip) {
      // For teachers, flip to show/edit tip on the back
      onFlip(e);
    }
  };

  return (
    <div className="info-tooltip-container">
      <button
        className={`tip-icon ${tip ? "has-tip" : ""}`}
        onClick={handleClick}
        disabled={isStudentView && !tip}
      >
        <FontAwesomeIcon icon={faRetweet} size="lg" />
      </button>
    </div>
  );
};

export default TipButton;
